import { Chevron } from './PastillesDeReglage';
import { useMenuOuvert } from '../partage/useMenuOuvert';
import { EN_DEVELOPPEMENT, PLAN_DE_VIE, TOUS } from '../partage/vocabulaire';
import './ChoixDuDossier.css';

/**
 * Le sélecteur « Plan de vie » de « Maintenant », à côté de « Tous les projets » (chantier
 * `revue-design`, ticket 01, `design/maintenant.html`, décision d'Igor du 2026-10-03,
 * « Maintenant » 9). Les plans de vie sont un chantier à part : d'ici là, il s'affiche, et un
 * clic dit seulement qu'ils sont en cours de développement. Rien ne se choisit, rien ne filtre.
 */
export function ChoixDuPlanDeVie() {
  const menu = useMenuOuvert();
  return (
    <div className="choix-dossier" ref={menu.ref}>
      <button
        type="button"
        className="choix-plan-de-vie"
        aria-expanded={menu.ouvert}
        onClick={() => menu.setOuvert(!menu.ouvert)}
      >
        <span className="choix-plan-de-vie-nom">{PLAN_DE_VIE}</span>
        <span>{TOUS}</span>
        <Chevron />
      </button>
      {menu.ouvert && (
        <p className="choix-dossier-menu choix-plan-de-vie-mot" role="status">
          {EN_DEVELOPPEMENT}
        </p>
      )}
    </div>
  );
}
